// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"fXhdc","iconSuccess":"V_Q5b","success-icon":"Fqo5V","container":"GBlmB","initialContainer":"W2_1u"};